import styled from '@emotion/styled';

import { ICustomTheme } from 'interfaces';

type Theme = {
  theme?: ICustomTheme;
};

export const Container = styled.div({
  width: '100%',
});

export const ToolBar = styled.div<Theme>(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(4),
}));

export const SeeMyPositionContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isDisabled',
})<{
  theme: ICustomTheme;
  isDisabled: boolean;
}>(({ theme, isDisabled }) => ({
  cursor: isDisabled ? 'not-allowed' : 'pointer',
  display: 'flex',
  alignItems: 'center',
  color: isDisabled ? theme.palette.grey[400] : theme.colors.paletteFromBO.main,
  fontWeight: theme.typography.fontWeightBold,
  '& span': {
    margin: theme.spacing(1),
  },
}));

export const GoalUnit = styled.span<Theme>(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  textTransform: 'lowercase',
  [theme.breakpoints.down('xs')]: {
    fontSize: theme.typography.caption.fontSize,
  },
}));
